<!-- Footer Start -->
<div class="container-fluid bg-dark text-white-50 footer pt-5 mt-5">
    <div class="container py-5">
        <div class="pb-4 mb-4" style="border-bottom: 1px solid rgba(226, 175, 24, 0.5) ;">
            <div class="row g-4">
                <div class="col-lg-3">
                    <a href="#">
                        <!-- <h1 class="text-primary mb-0">Logo</h1> -->
                        <img width="200" height="80" src="../assets/img/AcozamLogo_300x126.png" class="custom-logo" alt="" decoding="async" srcset="../assets/img/AcozamLogo_300x126.png">

                    </a>
                </div>
                <div class="ms-auto col-lg-3">
                    <div class="d-flex justify-content-end pt-3">
                        <a class="btn  btn-outline-secondary me-2 btn-md-square rounded-circle" href=""><i class="fab fa-twitter"></i></a>
                        <a class="btn btn-outline-secondary me-2 btn-md-square rounded-circle" href=""><i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-outline-secondary me-2 btn-md-square rounded-circle" href=""><i class="fab fa-youtube"></i></a>
                        <a class="btn btn-outline-secondary btn-md-square rounded-circle" href=""><i class="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-5">
            <div class="col-lg-3 col-md-6">
                <div class="footer-item">
                    <h5 class="text-light mb-3">Corporativo Biomedico Acozam S. A. de C. V.</h5>
                    <!-- <p class="mb-4">typesetting</p>
                    <a href="" class="btn border-secondary py-2 px-4 rounded-pill text-primary">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex flex-column text-start footer-item">
                    <h4 class="text-light mb-3">Información de la tienda</h4>
                    <a class="btn-link" href="/about">Nosotros</a>
                    <a class="btn-link" href="/contact">Contactanos</a>
                    <a class="btn-link" href="">Plitica de privacidad</a>
                    <a class="btn-link" href="">Terminos y Condiciones</a>
                    <!-- <a class="btn-link" href="">Return Policy</a> -->
                    <!-- <a class="btn-link" href="">FAQs & Help</a> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex flex-column text-start footer-item">
                    <h4 class="text-light mb-3">Cuenta</h4>
                    <a class="btn-link" href="">Mi Cuenta</a>
                    <!-- <a class="btn-link" href="">Shop Details</a> -->
                    <a class="btn-link" href="">Carrito</a>
                    <!-- <a class="btn-link" href="">Wishlist</a> -->
                    <a class="btn-link" href="">Mis Compras</a>
                    <!-- <a class="btn-link" href="">International Orders</a> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="footer-item">
                    <h4 class="text-light mb-3">Contacto</h4>
                    <p>Dirección: Manuel Avila Camacho No. 27 Col. El Potrero Atizapan de Zaragoza Edo. Mex. CP 0529</p>
                    <a>Correo: contacto&#64;acozam.com</a>
                    <p> Tel.: 5558249337</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer End -->

<!-- Copyright Start -->
<div class="container-fluid copyright bg-dark py-4">
    <div class="container">
        <div class="row">
            <!-- <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                <span class="text-light"><a href="#"><i class="fas fa-copyright text-light me-2"></i>Your Site Name</a>, All right reserved.</span>
            </div> -->
            <!-- <div class="col-md-6 my-auto text-center text-md-end text-white">
                Designed By <a class="border-bottom" href="https://htmlcodex.com">HTML Codex</a> Distributed By <a class="border-bottom" href="https://themewagon.com">ThemeWagon</a>
            </div> -->
        </div>
    </div>
</div>
<!-- Copyright End -->

<a (click)="backTop()" class="btn btn-primary border-3 border-primary rounded-circle back-to-top"><i class="fa fa-arrow-up"></i></a>
